<template>
  <div class="page-fixed-line">
    <div class="page-footer-content" :style="{width: width+'px'}" v-if="pageType === 'default'">
      <Button type="primary" @click="confirm" :disabled="disabled">{{text}}</Button>
    </div>
    <div class="page-footer-content" :style="{width: width+'px'}" v-if="pageType === 'newapply'">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'pageBottomLine',
  props: {
    text: String,
    disabled: Boolean,
    pageType: {
      type: String,
      default: 'default'
    }
  },
  computed: {
    width() {
      return this.$store.state.app.width || 1000
    }
  },
  methods: {
    confirm() {
      this.$emit('confirm')
    }
  }
}
</script>

<style lang="scss">
  // 固定底部条条
  .page-fixed-line {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 1;
    box-shadow: 0px -2px 4px 0px rgba(0,0,0,0.03);
    background: #fff;
    height: 60px;
    padding: 16px 0;
    z-index: 4;
  }
  .page-footer-content {
    margin: 0 auto;
    text-align: right;
  }
</style>
